import React from "react";


import {
    Col
} from "react-bootstrap";


import {
    CardComponent,
    CardContentComponent,
    CardTitleComponent,
    CardSubTitleComponent,
    CardDescriptionComponent,
    SvgIconComponent
} from "@Components/Elements";


import "./index.scss";
import parseHTML from "html-react-parser";


type CardIconType = {
    iconSrc: string;
    iconSize?: 'sm' | 'md' | 'lg' | 'xl';
    iconBackground?: 'none' | 'default' | 'primary';
}


type IconCardComponentProps = {
    cardIcon: CardIconType;
    cardTitle?: string;
    cardSubTitle?: string;
    cardDescription?: string;
    cardExtraDescription?: string;
    cardOrientationType?: 'horizontal' | 'vertical';
    cardActiveStatus?: boolean;
    xs?: number; xl?: number;
};


export const IconCardComponent:React.FC<IconCardComponentProps> = ({
    cardIcon, cardTitle, cardSubTitle, cardDescription, cardExtraDescription,
    cardOrientationType = 'vertical', cardActiveStatus = true,
    xs = 12, xl
}) => {


    return (
        <CardComponent xs={xs} xl={xl} type={1} className={`icon-card-component icon-card-icon-size-${cardIcon.iconSize} card-orientation-${cardOrientationType} card-${cardActiveStatus ? 'active' : 'disabled'}`}>

            <Col xs={'auto'} lg={cardOrientationType === 'vertical' ? 12 : 'auto'} className={`card-icon-component`}>
                <SvgIconComponent
                    iconSource={cardIcon.iconSrc}
                    className={`card-icon-svg-icon icon-size-${cardIcon.iconSize} icon-background-${cardIcon.iconBackground}`}
                />
            </Col>

            <CardContentComponent
                lg={cardOrientationType === 'vertical' ? 12 : 'auto'}
                className={`orientation-${cardOrientationType}`}
            >

                {cardTitle &&
                <CardTitleComponent
                    cardTitle={cardTitle}
                    cardTitleType={'special'}
                />
                }

                {cardSubTitle &&
                <CardSubTitleComponent
                    cardSubTitle={cardSubTitle}
                />
                }

                {cardDescription &&
                <CardDescriptionComponent
                    cardDescription={cardDescription}
                />
                }

                {cardExtraDescription &&
                <Col xs={12} className={'card-extra-description-component'}>
                    {parseHTML(cardExtraDescription)}
                </Col>
                }

            </CardContentComponent>

        </CardComponent>
    );

};


export default IconCardComponent;
